import { z } from 'zod';
import { renderReportSchema } from './report.js';
export const widgetActionSchema = z.object({
    name: z.string(),
    type: z.enum(['send', 'prefill', 'open-panel', 'set-filter']),
    prompt: z.string().optional(),
    row: z.record(z.string(), z.unknown()).optional(),
    filters: z.record(z.string(), z.string()),
});
/** Messages the host script inside the frame posts to the page. */
export const widgetFrameMessageSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('mf-widget:height'), height: z.number() }),
    z.object({ type: z.literal('mf-widget:action'), action: widgetActionSchema }),
    z.object({ type: z.literal('mf-widget:report'), report: renderReportSchema }),
    /** A `data-link` asks the page to open its page: the frame has no popups of its own. */
    z.object({ type: z.literal('mf-widget:link'), url: z.string() }),
    /** An `<img data-asset>` asks the page for its image, which the frame cannot fetch itself. */
    z.object({ type: z.literal('mf-widget:asset'), id: z.string(), assetId: z.string() }),
    z.object({
        type: z.literal('mf-widget:capture-result'),
        id: z.string(),
        png: z.string().startsWith('data:image/png;base64,').optional(),
        error: z.string().optional(),
    }),
]);
